var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Link',{staticClass:"group flex items-center justify-between p-3 rounded-md",class:[_vm.activeClass],attrs:{"href":_vm.href,"aria-current":"page"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }